import { cn } from "helper/Utils";
import React from "react";
import { FormMessage } from "./FormMessage";

const InputRC = ({
  type = "checkbox", // "checkbox" or "radio"
  name,
  value,
  label,
  checked = false,
  onChange,
  disabled,
  className = "",
  inputClassName = "",
  register, // React Hook Form register function
  validation, // Validation rules for React Hook Form
  error,
}) => {
  return (
    <>
      <label htmlFor={name} className={`group input-group flex items-center cursor-pointer space-x-2.5 ${className}`}>
        <div className={cn("relative flex items-center justify-center", type === "checkbox" ? "min-w-4 min-h-4" : "w-3.5 h-3.5")}>
          <input
            type={type}
            name={name}
            value={value}
            // checked={checked}
            onChange={onChange}
            disabled={disabled}
            {...(register ? register(name, validation) : {})} // Use React Hook Form register if provided
            className={cn(
              "appearance-none peer",
              type === "checkbox"
                ? "w-4 h-4 rounded bg-white/15 checked:bg-primary checked:border-primary"
                : "w-3.5 h-3.5 rounded-full bg-white ring ring-white ring-opacity-15 checked:ring-0",
              inputClassName
            )}
          />
          {type === "checkbox" && (
            <svg
              className={cn(
                " pointer-events-none cursor-pointer absolute rounded flex items-center justify-center inset-0 w-full h-full text-white m-auto  peer-checked:bg-primary peer-checked:border-primary peer-checked:scale-100 scale-0 transition-all duration-[.3s] ease-in-out"
                // checked ? "block" : "hidden"
              )}
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={3}
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          )}
          {type === "radio" && (
            <span
              className={cn(
                "pointer-events-none cursor-pointer absolute rounded-full flex justify-center items-center inset-0 min-w-full h-full m-auto  peer-checked:bg-primary peer-checked:scale-100 scale-0 transition-all duration-[.4s] ease-in-out"
              )}
            >
              <span className="w-[9px] h-[9px] border-[1.5px] border-white rounded-full"></span>
            </span>
          )}
        </div>
        <span className="text-white/70 text-[12px] leading-none">{label}</span>
      </label>
      {error && <FormMessage message={error} />}
    </>
  );
};

export default InputRC;
